import * as themeCart from '@shopify/theme-cart';
import { formatMoney } from '@shopify/theme-currency';
import { store } from '../../vuex/store';
import getUpsellHierarchy from '../../util/getUpsellHierarchy';
import Vue from 'vue';
import axios from 'axios'


export const cart = {
    init() {
        cart.initializeVue();
    },
    initializeVue(state) {
        // // eslint-disable-next-line
        const process = null;
        const cartDrawerVue = new Vue({
            el: '#newCart',
            store,
            delimiters: ['#{', '}'],
            data: {
                customer: false,
                loyaltyTier: 'Bestie Status',
                loyaltyDoublePoints: false,
                shopifyRoutes: '',
                freeShipping: false,
                freeShippingWidth: 'width:0%;',
                /** Type definitions for cart Flags */
                finalSaleTypes: ['hi leg','bikini','hipster','thong','cheeky','boyshort','tanga','shorty','hikini' ],
                braTypes: ['t-shirt','push up','contour','underwire','balconette','strapless','plunge','wire free', 'bralette'],
                undieTypes:['hi leg','bikini','hipster','thong','cheeky','boyshort','tanga','shorty','hikini'],
                loungeTypes:['chemise','cami'],
                swimTypes:["swim top", "swim bottoms", "sale-swim top", "sale-swim bottoms"],
                misc_types: ['accessories', 'bodysuit', 'garter belts'],
                /** End Flag Definitions */
                gwp: false,
                gwpObj: {},
                windowObj: {},
                cartInfoObj: {},
                gwpsInCart: [],
                gwpToRemove: 0,
                gwpCurrent:0,
                currentSubtotal: 0, 
                gwpTier: {},
                gwpCurrentThresh: 0,
                gwpInCart: false,
                incentiveBar: {},
                incentiveOn: false,
                incentiveStatus: [],
                incentiveTier: 0,
                dollarAmnt: 0,
                incentiveHeadline: '',
                ncentiveHeadlineBold: '',
                incentiveBarNext: '',
                incentiveBarNext2: 0,
                incentive1: '',
                incentive2: '',
                incentive3: '',
                incentivesComplete: false,
                currentThreshold: 0,
                currentNextTier: 0,
                upsellVariant: '',
                upsellSalePrice: 0,
                upsellSaleConversion:0,
                upsellStrikePrice: 0,
                upsellBundleHandle: '',
                upsellBundleAdded: false,
                grouped_variants: [],
                final_unique_ids: [],
                recommendedProducts: [],
                recoUpsellVariant: '',
                recoBundleVariants: [],
                recoBundleSelected: [],
                dynamicUpsell: [],
                dynamicUpsellVariant: '',
                lowInStockThreshold: 15,
                cartFlags: [],
                freeShippingThreshold: 0,
                windowHeight: 0,
                recoRailLogicItemTitle: '',
                totalSavings: 0
      
            },
            computed: {
                cart:{
                    get(){
                        return this.$store.getters["cart/cart"];
                        
                    },
                    set(){
                        return true;
                    }
                },
                cartIds: function(){
                    // array of all items in cart
                   return this.$store.getters["cart/cart"].items.map(item => item.product_id)
                },
                cartCounter: function(){
                    // return this.$store.state.cart.cart.item_count;
                   return this.$store.getters["cart/cartCount"]
                },
                loyaltyPoints: function(){
                    let thePoints = Math.floor(this.$store.getters["cart/totalPrice"] / 100)
                    if (this.loyaltyTier == 'Total Boss Status'){
                        thePoints = thePoints * 2
                    }else if (this.loyaltyTier == 'Powerhouse Status'){
                        thePoints = thePoints * 3
                    }
                    if(this.loyaltyDoublePoints){
                        thePoints = thePoints * 2
                    }
                    return thePoints
                },
                freeShippingCopy: function(){
                    let the_subtotal = this.$store.getters["cart/totalPrice"] / 100
                    let the_copy = ''
                    let threshold = this.shopifyRoutes === "/en-ca/" ? this.freeShippingThresholdCan : this.freeShippingThreshold
                    if (the_subtotal >= (threshold / 100)){
                         this.freeShipping = true
                         the_copy = 'score! you earned free shipping'
                         this.freeShippingWidth = 'width:100%;'
                    }else{
                         this.freeShipping = false
                         let amntLeft = ((threshold / 100) - the_subtotal).toFixed(2);
                         the_copy = this.shopifyRoutes === "/en-ca/" ? `$${amntLeft} CAD away from free shipping...` :`$${amntLeft} away from free shipping...`
                         let theWidth = Math.floor(the_subtotal * (100 / (threshold / 100)))
                         this.freeShippingWidth = `width:${theWidth}%;`; 
                    }
                   return the_copy
                },
                dynamicUpsellShow: function(){
                    //NOT READY YET
                    // if the cart subtotal is over $25 and we're in USA 
                    if(this.$store.getters["cart/cart"].items_subtotal_price >= 2400 && this.shopifyRoutes === '/'){
                        try{
                            let theUpsell = document.getElementById("dynamicUpsell-action")
                            console.log("THE UPSELL")
                            console.log(theUpsell)
                        } catch(err) {
                            console.log(err.message)
                        }
                        return true
                    } else {
                        return false
                    }
                },
                upsellSingleShow: function(){
                    // if the cart subtotal is over $25
                    if ( this.$store.getters["cart/cart"].items_subtotal_price >= 100 && this.cartInfoObj.singleUpsell){
                        //convert the price and strikeout to cad
                        if(this.shopifyRoutes === "/en-ca/"){        
                            /*
                                Using the upsell product price which is already converted to CAD for the strike price
                                Converting the theme setting for sale price to CAD
                            */
                            const rate = window.Shopify.currency.rate
                            this.upsellSalePrice = ((this.upsellSaleConversion / 100) * rate).toFixed(2)
                            this.upsellStrikePrice = this.upsellProduct.price
                        }
                        let theUpsell = document.getElementById("cartUpsell-action");
                        let variantID = theUpsell && parseInt(theUpsell.getAttribute('data-variantid'));
                        let upsellProductId = theUpsell && parseInt(theUpsell.getAttribute('upsell-productId'))
                        
                        //check if the upsell is a bundle
                        if(theUpsell && theUpsell.getAttribute('bundle-handle')){
                            this.upsellBundleHandle = theUpsell.getAttribute('bundle-handle')
                            this.upsellBundleTitle = theUpsell.getAttribute('bundle-title')
                            this.getBundleData()
                        }
                        let cartItems = this.$store.getters["cart/cart"].items;

                        console.log("CART ITEMS")
                        console.log(cartItems)

                        let upsellInCart = cartItems.find(item => {
                            return item.variant_id === variantID || upsellProductId === item.product_id
                        });

                        let upsellBundleInCart = cartItems.find(item => {
                            return item.properties._bundleTitle && item.properties._bundleTitle === this.upsellBundleTitle
                        })

                        // is the upsell in cart
                        if(upsellInCart || upsellBundleInCart){
                            return false
                        }else{
                            return true
                        }
                    }else{
                        return false
                    }
                },
                upsellSingleSelect: function(){ // I feel like we don't need this function 
                    this.addUpsell(this.upsellVariant);
                },
                cartHeight: function(){
                    /*
                    Returns max-height value in px
                    */
                    const vh = this.windowHeight
                    const incentive = this.incentiveOn
                    const gwp = this.gwp 
                    const upsell = this.upsellSingleShow
                    let height = vh - 205 //initial height

                    const offsets =  {
                        incentive: 80,
                        gwp: 150,
                        upsell: 135
                    }

                    if(incentive){height -= offsets.incentive}
                    if(gwp){height -= offsets.gwp}
                    if(upsell){height -= offsets.upsell}

                    return `${height}px`
                }
            },
            watch:{
                cartCounter: function(newval, oldval){
                    console.log('new');
                    console.log(newval);
                    console.log('old');
                    console.log(oldval)
                    console.log( this.$store.getters["cart/cart"].items);
                    // Update Cart Count
                    const cartIconNum = document.getElementById('HeaderCartCount');
                    const cartIconNumLeft = document.getElementById('HeaderCartCount-left');
                    cartIconNum.textContent = `${newval}`;
                    cartIconNumLeft.textContent = `${newval}`;

                    // Run GWP logic 
                    this.gwpInit(this.$store.getters["cart/cart"].items);

                    // if incentive is on 
                    if(this.incentiveOn === true){
                        this.incentiveBarInit();
                    }

                    this.setCartItemFlags()
                    this.fetchRecommendedProducts();
                    // this.fetchDynamicUpsell();//maybe put this somewhere else to allow for hiding of the dynamic upsell
                },
            },
            filters: {
                currency: (price) => {
                  return formatMoney(price, window.Shop._MONEY_FORMAT_);
                }
              },            
            methods: { 
                cartClose(){
                    let theCart = document.getElementById("shopify-section-cart");
                    theCart.classList.remove("is-open");
                    document.body.classList.remove("noscroll-mobile")
                    // shopify-section-cart
                },
                rewardsClick(){
                    console.log("REWARDS CLICK")
                    gtag('event', 'rewards_click', {
                        'logged_in' : false,
                        'cart_subtotal': (this.cart.total_price / 100).toFixed(2),
                        'units': this.cart.item_count,
                        'points': Math.floor((this.cart.total_price / 100).toFixed(2))
                    })
                },
                /*
                upsell types: static, dynamic or reco
                */
                addUpsell(variantID, upsellType, recoProduct){ 
                    console.log('clicked upsells')

                    if(variantID != ''){
                                               
                        const payload = {
                            id: variantID,
                            props: { quantity: 1 },
                          };
                          this.$store.dispatch('cart/addItem', payload).then(function(){
                            console.log('added upsells')
                          });

                        /* GA4 Events */
                        let product = recoProduct ? recoProduct : this.upsellProduct
                        let slicePosition = product.title.indexOf(':')
                        let productTitle = product.title.slice(0, slicePosition)
                        let productColor = product.title.slice(slicePosition + 2)
                        let variant = product.variants.find(variant => variant.id === variantID).option1
                        let type = recoProduct ? 'reco_rail' : 'upsell_product'
                        let isBundle = false // come back to this

                        if(upsellType === 'reco'){
                            //reco rail
                            gtag('event', 'reco_rail', {
                                'added_product': product.title,
                                'cart_subtotal': (this.cart.total_price / 100).toFixed(2),
                                'units': this.cart.item_count,
                                'logic_product': this.recoRailLogicItemTitle
                            })
                        } else {
                            //single upsell (static or dynamic)
                            gtag('event', 'added_upsell', {
                                'product': product.title,
                                'type': upsellType,
                                'cart_subtotal': (this.cart.total_price / 100).toFixed(2),
                                'units': this.cart.item_count
                            })
                        }  
                        //added_prod
                        gtag('event', 'added_prod', {
                            'product': productTitle,
                            'variant': variant,
                            'color' : productColor,
                            'type': type,
                            'bundle': isBundle
                        })
                        /* End GA4 Events */
                    }
                    //this changes selected options back to default in dropdowns
                    this.upsellVariant = ''
                    this.recoUpsellVariant = ''
                },
                getBundleData(){
                    let theHandle = this.upsellBundleHandle;
                    let vm = this;
                    let the_url = window.Shopify.routes.root + 'products/'+theHandle+'?view=bundlejson'
                    let promise = axios.get(the_url)
                        .then(response => {
                            console.log('build getData')
                            // console.log(response);
                            vm.productData = response.data
                            vm.is_diff_size = response.data.different_sizes
                            vm.qty_to_add = parseInt(response.data.single_prod_qty)
                            vm.getSizes();
                            vm.buildSizes();

                            console.log("grouped_vars")
                            console.log(vm.grouped_variants)
                            return Promise.resolve()
                        })
                        .catch(error => {
                            console.log(error);
                            return Promise.reject(error)
                        });
                    
                    return promise
                },
                getSizes(){
                    this.ungrouped_variants = []
                    let vm = this;
                    if(this.is_diff_size === false){ 
                        let size_range = this.productData.bundle_same[0].variants.map(function(variant){
                            // console.log(variant.option1);
                            return variant.option1
                        })
                        this.same_sizes = size_range
                        // push all variants to ungrouped 
                        this.productData.bundle_same.forEach(product => {
                            product.variants.forEach(variant => {
                            vm.ungrouped_variants.push(variant)
                            })
                        });
                    }else{
    
                    }
                },
                buildSizes(){
                    console.log('build sizes')
                    let vm = this;
                    const products_count = this.productData.bundle_same.length;
                    if(this.is_diff_size == false){
                    const the_sizes = this.same_sizes
                    const same_prod_qty = this.qty_to_add
                    let the_size_arr = the_sizes.map(size => {
                        let the_current_size = size;
                        let the_matching_variants = vm.ungrouped_variants.filter(function(variant){
                        // if opt1 = current size, add releveant info as an obj to the array
                        if (variant.option1 === the_current_size ){
                            return variant
                        }else{
                            return false
                        }
                        })
                        .map(variant => {
                        // console.log('map');
                        return { "id": variant.id, "qty": variant.qty, "sku": variant.sku }
                        });
                            
                        let is_sold_out = the_matching_variants.every(function (number){
                        return number.qty > same_prod_qty;
                        });
                        let variants_count = (products_count === the_matching_variants.length)?true:false;
                        let the_conditions_array = [!is_sold_out, variants_count]
                        let the_conditions = the_conditions_array.every(Boolean)
                    
                        return {"size": size, "soldout": the_conditions, "variants": the_matching_variants}
                    });
    
                    this.grouped_variants = the_size_arr;
                    }else{
                    // console.log('build diff Sizes');
                    let the_size_arr = this.diff_sizes.map(size => {
                        // current grouping type
                        let the_current_type = size.type;
                        let the_group_type = the_current_type+"_group"                    
                        // loop over the current sizes, find the matching size in our grouped array,
                        let the_grouped_sizes = size.sizes.map(sz => {
                            let the_current_size = sz
                            // filter ALL variants, grab the variants where the curernt type matches the group & the current size is the current size
                            let grouped_vars = vm.ungrouped_variants.filter(function(variant){
                                if (variant.option1 === the_current_size && vm[the_group_type].includes(variant.type) ){
                                    return variant
                                }else{
                                    false
                                }
                            }).map(function(variant){
                                console.log('map');
                                return { "id": variant.id, "qty": variant.qty, "sku": variant.sku } 
                            });
                                
                            let is_sold_out = grouped_vars.every(number => {
                                return number.qty > 1;
                            });
                            
                            return {"size": the_current_size, "soldout": !is_sold_out,  "the_variants": grouped_vars }
    
                        }); //end grouped_sizes
                        // return the current type + the grouped sizes 
                        return { "type": the_current_type, "label":the_label, "sizes": the_grouped_sizes }
                    }); 
                    this.grouped_variants = the_size_arr;
                    }
                    
                },
                addBundleUpsell(){
                    console.log("ADDING UPSELL BUNDLE")
                    this.added = true;
                    const the_qty = this.qty_to_add;
                    // whichever size is currently selected, find the IDs and add it to cart
                    // check the current selected size
                    const selected_bundle_size = this.upsellVariant
                    let all_variants = this.grouped_variants
                    let vm = this;
                    let the_ids =[]
                    let just_ids = []
                    let dupe_id_qty = {};

                    // Filter through the current sizes, grab their IDs 
                    all_variants.filter(function(size){
                        if (size.size === selected_bundle_size){
                            console.log('matching')
                            just_ids = size.variants.map(function(variant){
                                console.log('variant.id')
                                console.log(variant.id)
                                // return variant.id
                                return variant.id
                            })
                            return just_ids
                        }
                    });

                    // // Grab the num of times we have each variant ID 
                    for (const num of just_ids) {
                    dupe_id_qty[num] = dupe_id_qty[num] ? dupe_id_qty[num] + 1 : 1;
                    }
                    console.log('dupe_id_qty');
                    console.log(dupe_id_qty)
    
                    the_ids = just_ids.map(function(variant){
                    let the_final_qty = the_qty * dupe_id_qty[variant]
                    return {id: variant, quantity:the_final_qty, properties: { "_bundle": true, "_bundleTitle": vm.productData.current_title } }
                    })
    
            
                    console.log('the final IDs')
                    console.log(the_ids)
    
                    if (this.productData.add_os_item){
                        // grab the one sized item, jam it into the IDs rigth away 
                        this.productData.one_size.forEach(function(product){
                            // console.log(product.variants[0].id)
                            // the_ids.push(product.variants[0].id) 
                            the_ids.push({id: product.variants[0].id, quantity:the_qty, properties: { "_bundle": true, "_bundleTitle": vm.productData.current_title } })
                        });
                    }
    
                    let final_unique_ids = []
                    final_unique_ids =  the_ids.filter((v,i,a)=>a.findIndex(t=>(t.id === v.id))===i)
                    console.log('final_ids');
                    console.log(final_unique_ids);

                    // Add to cart via cart API
                    let the_url = window.Shopify.routes.root + 'cart/add.js';
                    let cartPromise = $.post(the_url, {
                        items: final_unique_ids
                    })
                    .done(() => {
                        vm.added = true;
                        store.dispatch('cart/updateCart');
                    })
                    .fail(err => {
                        console.log(err)
                    })
                          
                },
                addRecoBundle(variants){
                    console.log("ADD RECO BUNDLE")
                    let items = []
                    variants.forEach(variant => {
                        items.push({id: variant.id, quantity:1, properties: { "_bundle": true } })
                    })
                    // Add to cart via cart API
                    let the_url = window.Shopify.routes.root + 'cart/add.js';
                    let cartPromise = $.post(the_url, {
                        "items": items
                    })
                    .done(() => {
                        store.dispatch('cart/updateCart');
                    })
                    .fail(err => {
                        console.log(err)
                    })

                    //changes selected back to 'choose size' in the dropdown for all reco bundles
                    this.recoBundleSelected = Array(this.recoBundleSelected.length).fill('')
                },
                updateItem(key, qty, amount) {
                    let newQty = (qty += amount);
                    if (newQty <= 0) {
                      this.removeItem(key);
                    } else {
                      this.busy = 1;
                      let payload = { key: key, props: { quantity: newQty } };
                      this.$store.dispatch("cart/updateItem", payload);
                    }
                },
                removeItem(key, productTitle, variantTitle) {
                    this.removing = 1;
                    this.$store.dispatch("cart/removeItem", key)
                    if(productTitle && variantTitle){
                        //GA4 Event
                        gtag('event', 'remove_item', {
                            'product': productTitle,
                            'cart_subtotal': (this.cart.total_price / 100).toFixed(2),
                            'variant': variantTitle
                        })
                    }
                },
                gwpInit(cartItems) {
                    let the_subtotal = this.$store.getters["cart/cart"].total_price / 100;
                    this.currentSubtotal = the_subtotal;

                    if (this.gwpObj.gwpStatus === true) {
                        console.log('GWP BEGINNNNN');
                        // find the tier that qualifies for GWP based on subtotal by location
                        let theTier = this.getGwpTier(the_subtotal);
                        this.gwpTier = theTier[0];

                        if (theTier.length) {
                            // if you've hit a tier, set the current threshold and GWP product 
                            this.gwpCurrentThresh = theTier[0][this.shopifyRoutes];
                            this.gwpCurrent = theTier[0]['products'];
                            // run the GWP logic to see if we need to add GWPs to cart or remove them
                            this.handleGwpInCart(cartItems);
                        } else {
                            // no tier, you dont qualify for a GWP, remove it from cart
                            let removeGWP = cartItems.find(item => item.product_type === 'gwp');
                            if(removeGWP){
                                console.log('removeGWP')
                                console.log(removeGWP)
                                this.removeGwpFromCart(removeGWP.id);
                            }
                        }
                    } else {
                        console.log('gwp is off');
                        // GWP is off, remove any that exist from cart 
                        let removeGWP = cartItems.find(item => item.product_type === 'gwp');
                        if(removeGWP){
                            console.log('removeGWP')
                            console.log(removeGWP)
                            this.removeGwpFromCart(removeGWP.id);
                        }
                        
                    }
                },
                getGwpTier(the_subtotal) {
                    return this.gwpObj.threshold.filter(tier => the_subtotal >= tier[this.shopifyRoutes]);
                },
                handleGwpInCart(cartItems) {
                    console.log('handling GWP');
                    let currentGWPInCart = false;
                    let otherGWP = false;
                    let gwpsToRemove = [];
                    let gwpToRemove;
                    // grab any GWP items in cart 
                    let allGWPitems = cartItems.filter(item => item.product_type === 'gwp');
                    this.gwpsInCart = allGWPitems;

                    if (allGWPitems.length > 0) {
                        // if there's at least 1 GWP, loop over them and remove each GWP that doesn't qualify based on threshold/location
                        allGWPitems.forEach(gwp => {
                        if (gwp.variant_id !== this.gwpCurrent) {
                            gwpsToRemove.push(gwp.variant_id);
                            otherGWP = true;
                            gwpToRemove = gwp.variant_id;
                        } else {
                            currentGWPInCart = true;
                        }
                        });
                    }
                    this.gwpInCart = currentGWPInCart
                    if (!currentGWPInCart && cartItems.length >= 1) {
                        this.addGwpToCart();

                    } else if (currentGWPInCart && cartItems.length === 1) {
                        this.removeItem(allGWPitems[0].key);
                    }

                    if (otherGWP) {
                        this.removeGwpFromCart(gwpToRemove);//
                    }
                },
                addGwpToCart() {

                    //GA4 Event
                    let product = this.gwpObj.threshold.find(index => index.products === this.gwpCurrent).productTitle
                    gtag('event', 'gwp_added', {
                        'product': product
                    })

                    const payload = {
                        id: this.gwpCurrent,
                        props: { quantity: 1 },
                    };

                    this.$store.dispatch('cart/addItem', payload).then(() => {
                        console.log('added GWPs');

                    });
                },
                removeGwpFromCart(gwpToRemove) {
                    let removeGWP = this.gwpsInCart.find(item => item.product_type === "gwp");
                    if (removeGWP) { 
                        if (gwpToRemove) {
                            console.log('gwpToRemove')
                            console.log(gwpToRemove)
                            $.post(window.Shopify.routes.root+'cart/change.js', { quantity: 0, id: gwpToRemove })
                                .done(data => {
                                console.log("second success");
                                console.log(data);
                                this.$store.dispatch('cart/updateCart');
                                })
                                .fail(() => {
                                console.log("error");
                                })
                                .always(() => {
                                console.log("finished");
                                });
                        } else {
                            this.removeItem(removeGWP.key);
                        }
                    }else {
                        let gwp = this.cart.items.find(item => item.id === gwpToRemove)
                        gwp && this.removeItem(gwp.key);
                    }
                },
                incentiveBarInit() {
                    console.log('incentive on');
                    const the_subtotal = this.$store.getters["cart/cart"].total_price / 100;
                    const currentLocation = this.shopifyRoutes;
                    const bar_type = this.incentiveBar.type;
                  
                    this.setIncentives(currentLocation);
                    const incentiveStatus = this.getIncentiveStatus(the_subtotal, currentLocation);
                  
                    this.incentiveStatus = incentiveStatus;
                  
                    if (incentiveStatus.length > 0) {
                      this.setIncentiveProperties(incentiveStatus[0], the_subtotal, currentLocation);
                    }
                    
                    if (this.dollarAmnt < 0) {
                      this.incentiveHeadline = this.incentiveBar.success;
                      this.incentiveHeadlineBold = ''
                      this.incentivesComplete = true
                    } else {
                      this.incentiveHeadline = 'from ' + this.currentIncentive
                      this.incentiveHeadlineBold = this.shopifyRoutes === "/en-ca/" ? '$' + this.dollarAmnt + ' CAD away' : '$' + this.dollarAmnt + ' away'
                      this.incentivesComplete = false
                    }
                    //GA4 Event   
                    if(incentiveStatus.length > 1 && !this.gwpsInCart.find(gwp => gwp.variant_id === this.gwpCurrent)){ 
                        
                        /* First index of incentiveStatus should be the currently met tier */
                        let location = this.shopifyRoutes === "/en-ca/" ? 'Canada' : 'US'
                        let incentive = location === 'Canada' ? this.incentiveStatus[0].incentives['/en-ca/'] : this.incentiveStatus[0].incentives['/']
                        let threshold = location === 'US' ? this.incentiveStatus[0].thresholds['/en-ca/'] : this.incentiveStatus[0].threshold['/']

                        gtag('event', 'incentive_bar', {
                            'tier': this.incentiveStatus[0].tier,
                            'incentive': incentive,
                            'threshold': threshold,
                            'cart_subtotal': (this.cart.total_price / 100).toFixed(2),
                            'units': this.cart.item_count,
                            'location': location
                        })
                    }
                },
                setIncentives(currentLocation) {
                    this.incentive1 = this.incentiveBar.incentives[currentLocation][0];
                    this.incentive2 = this.incentiveBar.incentives[currentLocation][1];
                  
                    if (this.incentiveBar.type === '3up') {
                      this.incentive3 = this.incentiveBar.incentives[currentLocation][2];
                    }
                },
                getIncentiveStatus(the_subtotal, currentLocation) {
                    return this.incentiveBar.tiers.filter(tier => the_subtotal >= tier['thresholds'][currentLocation]);
                },
                setIncentiveProperties(incentive, the_subtotal, currentLocation) {
                    this.incentiveBarNext = incentive['next_incentives'][currentLocation];
                    this.incentiveBarNext2 = incentive['next_tiers'][currentLocation];
                    this.currentThreshold = incentive['thresholds'][currentLocation];
                    this.currentNextTier = incentive['next_tiers'][currentLocation];
                    this.incentiveTier = incentive['tier'];
                    this.currentIncentive = incentive['next_incentives'][currentLocation];
                    this.dollarAmnt = incentive['next_tiers'][currentLocation] - the_subtotal;
                    this.dollarAmnt = this.dollarAmnt.toFixed(2);
                },
                buildRecoBundles(recoBundles){
                    /* 
                    This reuses the above code for bundling and should not be used together with a single upsell bundle.
                    for each bundle in the reco rail it goes through the whole process and then stores the options for each select
                    */
                    console.log("RECOBUNDLES")
                    console.log(recoBundles)
                    let recoBundleGroupedVariants = []
                    recoBundles.forEach(bundle => {
                        this.upsellBundleHandle = bundle.handle
                        this.getBundleData()
                        .then(() => { 
                            recoBundleGroupedVariants.push({"bundleId" : bundle.id , "groupedVariants" : this.grouped_variants})
                        })
                    })
                    this.grouped_variants = []
                    return recoBundleGroupedVariants
                    
                },
                getPriorityItemId() { //returns null if not found!
                    console.log("GET PRIORITY ITEM")
                    const upsellHierarchy = getUpsellHierarchy()

                    let priorityItem = null
                    let highestPriority = 0
                    this.$store.getters["cart/cart"].items.forEach(item => {

                        let priority = 0
                        try {
                            priority = upsellHierarchy.find(name => name.productTypes.includes(item.product_type)).priority //returns int
                        } catch(err) {
                            console.log(`Cart Item ${item.title} has product type of: ${item.product_type} which does not exist in upsell hierarchy - `+ err.message)
                        }
                        
                        console.log("PRIORITY")
                        console.log(priority)
                        if(priority > highestPriority){
                            highestPriority = priority
                            priorityItem = item
                        }
                    })
                    //set the recoPriorityItemTitle for use with GA4
                    this.recoRailLogicItemTitle = priorityItem && priorityItem.product_title

                    return priorityItem ? priorityItem.product_id : null
                },
                async fetchRecommendedProducts() {
                    //TESTING 
                    console.log("RECOMMENDED PRODUCTS")
                    const priorityItemId = this.getPriorityItemId()

                    let itemId = 0
                    if(priorityItemId){ 
                        itemId = priorityItemId
                    } else if(this.cart.items.length === 1){ // takes care of no priority item in cart
                        itemId = this.cart.items[0].product_id
                    } else {
                        return
                    }

                    const intent = "related"
                    
                    const recommendationsResponse = await fetch(`/recommendations/products.json?product_id=${itemId}&limit=3&intent=${intent}`);
                    this.recommendedProducts = await recommendationsResponse.json()
                    //if bundles exist in reccomended prods, build the options
                    let recoBundles = []
                    this.recommendedProducts.products.forEach(product => {
                        if(product.handle.includes('bundle') || product.handle.includes('-pack')){
                            recoBundles.push(product)
                            this.recoBundleSelected.push('') //for v-model and default selected empty string in dropdown
                        }
                    })
                    if(recoBundles.length > 0){
                        this.recoBundleVariants = this.buildRecoBundles(recoBundles)
                        console.log("RECOBUNDLEVARIANTS")
                        console.log(this.recoBundleVariants)
                    }
                 
                },
                async fetchDynamicUpsell() {
                    //NOT READY FOR USE YET
                    const cartItemIds =  this.$store.getters["cart/cart"].items.map(item => item.product_id);

                    const productId = cartItemIds[0];
                    const response = await fetch(`/recommendations/products.json?product_id=${productId}&limit=1&intent=related`)
                    const result = await response.json()
                    if(!this.cartInfoObj.singleUpsell){
                        this.dynamicUpsell = result.products[0]
                        this.upsellBundleHandle = this.dynamicUpsell.handle
                        this.upsellBundleTitle = this.dynamicUpsell.title
                        //if is bundle. needs to call this func
                        // this.getBundleData()
                    }
                    // return result.products[0] //return products
                },
                setCompareAtAndStandardFlags: function(){ 
                    let vm = this
                    vm.totalSavings = vm.cart.total_discount
                    this.cart.items.forEach((item, index) => {
                        const url = `/products/${item.handle}.js`
                        fetch(url)
                            .then(res => res.json())
                            .then(data => {
                                //append standard flag to cart item flags if applicable
                                const sfTag = data.tags.find(tag => tag.includes('sf--'))
                                const finalSaleTag = data.tags.find(tag => tag.includes('final sale'))
                                if(sfTag){
                                    const flag = sfTag.split('--')
                                        .pop()
                                        .split(':')
                                    const color = flag[0]
                                    const text = flag[1]
                                    this.cartFlags[index].push({text: text, class:`newCartBodyList-flag-${color}` })
                                }
                                if(finalSaleTag && !this.cartFlags[index].some(f => f.text === "final sale")){
                                    this.cartFlags[index].push({ text: "final sale", class: "newCartBodyList-flag-red" })
                                }
                                //set compare at prices
                                item.compare_at_price = data.compare_at_price
                                
                                //add to difference to total savings
                                if(data.compare_at_price){
                                    vm.totalSavings += (data.compare_at_price - data.price) * item.quantity
                                }
                            })
                            .catch(err => console.log("Error getting compare at prices. " + err))
                    })
                },
                async setCartItemFlags() {

                    //count bras & undies in cart for flag logic
                    let braCount = 0
                    let undieCount = 0
                    this.cart.items.forEach(item => {
                        if(this.braTypes.includes(item.product_type)){
                            braCount += item.quantity
                        } else if (this.undieTypes.includes(item.product_type)){
                            undieCount += item.quantity
                        }
                    })

                    //check inventory qtys asynchronously
                    let the_url = window.Shopify.routes.root + 'cart?view=inventoryjson'
                    axios.get(the_url)
                    .then(response => {
                        const inventoryQtys = response.data.items
                        console.log(inventoryQtys)
                        let flagArray = []
                        //set flags
                        this.cart.items.forEach(item => {
                            
                            let flags = []
                            let isLow = inventoryQtys.filter(inventoryItem => inventoryItem.id === item.id)[0].quantity <= this.lowInStockThreshold


                            if(isLow){ flags.push({ text: "only a few left!", class: "newCartBodyList-flag-blue" }) }
                            
                            if(this.finalSaleTypes.includes(item.product_type)){
                                flags.push({ text: "final sale", class: "newCartBodyList-flag-red" })
                            }
                            if(item.product_type === 'gwp'){
                                flags.push({text: "free gift", class:"newCartBodyList-flag-purple" })
                            } 
                            
                            flagArray.push(flags)
                        })
                        this.cartFlags = flagArray
                    })
                    .then(() => this.setCompareAtAndStandardFlags())
                    .catch(err => {
                        console.log(err)
                    })
                }
            },
            created(){
                this.shopifyRoutes = window.Shopify.routes.root
                this.customer = window.addlInfo.customer
                this.loyaltyTier = window.addlInfo.tier
                this.loyaltyDoublePoints = window.addlInfo.doublePoints
                this.windowObj = window.addlInfo
                this.cartInfoObj = window.cartInfo;
                this.gwpObj = window.gwp
                this.incentiveBar = window.Incentive;
                this.incentiveOn = window.Incentive.incentive_on
                this.upsellStrikePrice = window.cartInfo.upsellStrikePrice
                this.upsellSalePrice = window.cartInfo.upsellSalePrice
                this.upsellSaleConversion = window.cartInfo.upsellSalePrice //should remain const
                this.upsellProduct = window.cartInfo.upsellProduct
                this.freeShippingThreshold = window.cartInfo.freeShippingThreshold
                this.freeShippingThresholdCan = window.cartInfo.freeShippingThresholdCan
                /*
                for weirdness with mobile address bars
                Init this.windowHeight (bound to cartHeight) and then listen for resize
                */
                this.windowHeight = window.innerHeight
                if(window.innerWidth >= 1024){
                    document.querySelector('.newCartWrap').style.height = `${this.windowHeight - 20}px`
                }else{
                    document.querySelector('.newCartWrap').style.height = `${this.windowHeight}px`
                }
                
                document.querySelector('.newCartOverlay').style.height = `${this.windowHeight}px`

                window.addEventListener("resize", () => {
                    this.windowHeight = window.innerHeight
                    document.querySelector('.newCartWrap').style.height = `${this.windowHeight}px`
                    document.querySelector('.newCartOverlay').style.height = `${this.windowHeight}px`
                });
            },
            mounted() {
            } 
        });
    }
}